export const tdStyles = {
  border: 'none',
  borderBottom: '1px solid #eceeef',
  paddingTop: '1.1rem',
  minWidth: '3.2em',
  textAlign: 'right'
};

export const firstTdStyles = (disabled) => {
  return {
    ...tdStyles,
    textAlign: 'left',
    width: '30vw',
    fontWeight: '400',
    fontSize: '15px',
    cursor: disabled ? 'default' : 'pointer',
  }
};

export const selectStyles = {
  padding: '.2em',
  fontSize: '13px',
  fontWeight: '400',
  width: '10rem',
};

export const subRowStyles = {
  background: 'whitesmoke'
};

export const subRowTdStyles = {
  ...firstTdStyles,
  fontWeight: '350',
  fontSize: '14px',
  paddingLeft: '2.5em',
  cursor: 'default'
};